import { render, staticRenderFns } from "./SubmitCandidatesDialog.vue?vue&type=template&id=2982c8dd&"
import script from "./SubmitCandidatesDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitCandidatesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitCandidatesDialog.vue?vue&type=style&index=0&id=2982c8dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports